module.exports = __webpack_public_path__ + "static/img/no-data.9f71ec21.png";